"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMethodsForTestId = getMethodsForTestId;

function getMethodsForTestId(namespace, componentName) {
  var generateTestId = function generateTestId() {
    for (var _len = arguments.length, name = new Array(_len), _key = 0; _key < _len; _key++) {
      name[_key] = arguments[_key];
    }

    return [namespace, componentName].concat(name).filter(function (item) {
      return item !== '';
    }).join(':');
  };

  var getTestId = function getTestId() {
    if (namespace) {
      return {
        'data-test': generateTestId.apply(void 0, arguments)
      };
    }

    return null;
  };

  var getNamespace = function getNamespace() {
    if (namespace) {
      return generateTestId.apply(void 0, arguments);
    }

    return null;
  };

  return {
    getTestId: getTestId,
    getNamespace: getNamespace
  };
}